<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click.native="handleInput(null, null)"
                >添加
                </el-button
                >
            </el-form-item>

            <el-form-item class="query-form-item">
                <el-input
                    placeholder="标题"
                    v-model="query.name"
                    prefix-icon="el-icon-search"
                    @keyup.enter.native="onSubmit"
                    clearable
                >
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-refresh"
                    @click="onRest"
                ></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit"
                >查询
                </el-button
                >
            </el-form-item>
        </el-form>
        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
        <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
            @selection-change="handleSelectionChange"
            border
        >
            <el-table-column
                label="选择"
                prop="orderid"
                type="selection"
                :show-overflow-tooltip="true"
                width="50"
                align="center"
            />
            <el-table-column
                label="轮播图"
                prop="slidepicsite"
                align="center"
                width="200"
            >
                <template slot-scope="scope">
                    <el-popover placement="right" trigger="hover">
                        <img
                            :src="scope.row.url"
                            style="width:400px;border-radius:3px;"
                        />
                        <img
                            slot="reference"
                            :src="scope.row.url"
                            style="max-height: 50px;max-width: 50px;border-radius:5px;"
                        />
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="标题" align="center" prop="name"/>
            <el-table-column label="跳转链接" align="center" prop="jumpUrl"/>
            <el-table-column label="排序" align="center" prop="sort"/>
            <el-table-column label="状态" align="center" prop="isRelease">
                <template slot-scope="scope">
                    <el-switch
                        :active-value="2"
                        :inactive-value="1"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        v-model="scope.row.isRelease"
                        @change="backgroundChange(scope.row)"
                    ></el-switch>
                </template>
            </el-table-column>
            <el-table-column width="300" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button
                        type="primary"
                        size="mini"
                        @click.native="handleInfo(scope.$index, scope.row)"
                    >查看
                    </el-button
                    >
                    <el-button
                        type="primary"
                        size="mini"
                        @click.native="handleForm(scope.$index, scope.row)"
                    >修改
                    </el-button
                    >
                    <el-button
                        type="danger"
                        size="mini"
                        @click.native="handleDel(scope.row.id)"
                    >删除
                    </el-button
                    >
                </template>
            </el-table-column>
        </el-table>

        <div class="left-container">
            <el-button type="danger" size="small" @click="delGroup()"
            >删除已选
            </el-button
            >
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle"
                >取消选择
                </el-button
                >
            </transition>
        </div>
        <el-pagination
            class="pagination-container"
            background
            :page-size="query.pageSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper"
            :page-sizes="[10, 20, 30, 50]"
            :total="totalNumber"
        ></el-pagination>

        <!--增加-->
        <el-dialog
            :visible.sync="formInput"
            :before-close="hideFormAdd"
            width="800px"
            top="5vh"
            v-dialogDrag
        >
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="标题:" prop="name">
                    <el-input v-model="formData.name" type="text"/>
                </el-form-item>
                <el-form-item label="序列号:" prop="sort">
                    <el-input v-model="formData.sort" type="text"/>
                </el-form-item>
                <el-form-item label="跳转链接:" prop="jumpUrl">
                    <el-input v-model="formData.jumpUrl" type="text"/>
                </el-form-item>
                <el-form-item label="轮播图片:" prop="url">
                    <el-upload
                        v-show="pic_is_show"
                        class="avatar-uploader"
                        style="margin-bottom: 15px;"
                        accept=".png, .jpg, .gif, .jpeg, .bmp"
                        :action="uploadUrl"
                        :headers="{ hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg' }"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                    >
                        <img
                            v-if="formData.url"
                            :src="formData.url"
                            class="avatar"
                        />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideFormInput">取消</el-button>
                <el-button
                    type="primary"
                    @click.native="formSub()"
                    :loading="formLoading"
                >保存
                </el-button
                >
            </div>
        </el-dialog>

        <!--修改-->
        <el-dialog
            :visible.sync="formVisible"
            :before-close="hideForm"
            width="800px"
            top="5vh"
            v-dialogDrag
            title="修改"
        >
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="标题:" prop="name">
                    <el-input v-model="formData.name" type="text"/>
                </el-form-item>
                <el-form-item label="序列号:" prop="sort">
                    <el-input v-model="formData.sort" type="text"/>
                </el-form-item>

                <el-form-item label="跳转链接:" prop="jumpUrl">
                    <el-input v-model="formData.jumpUrl" type="text"/>
                </el-form-item>
                <el-form-item label="轮播图片:" prop="url">
                    <el-upload
                        v-show="pic_is_show"
                        class="avatar-uploader"
                        style="margin-bottom: 15px;"
                        accept=".png, .jpg, .gif, .jpeg, .bmp"
                        :action="uploadUrl"
                        :headers="{ hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg' }"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                    >
                        <img
                            v-if="formData.url"
                            :src="formData.url"
                            class="avatar"
                        />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button
                    type="primary"
                    @click.native="formSubmit()"
                    :loading="formLoading"
                >保存
                </el-button
                >
            </div>
        </el-dialog>

        <!--  查看 --->
        <el-dialog
            title="基本信息"
            :visible.sync="formInfo"
            :before-close="hideInfo"
            width="1200px"
            top="5vh"
            v-dialogDrag
        >
            <el-form :model="formData">
                <el-form-item
                    style="border-bottom:1px solid #ebeef5;"
                    label-width="0px"
                >
                    <el-form-item
                        label="标题:"
                        prop="name"
                        style="width:50%;display: inline-block;margin-left:0px;"
                    >
                        <div v-html="formData.name"/>
                    </el-form-item>
                </el-form-item>
                <el-form-item
                    style="border-bottom:1px solid #ebeef5;"
                    label-width="0px"
                >
                    <el-form-item
                        label="跳转链接:"
                        prop="slidepicaddress"
                        style="width:50%;display: inline-block;margin-left:0px;"
                    >
                        <input v-model="formData.jumpUrl" type="text" readonly/>
                    </el-form-item>
                    <el-form-item label="状态:" style="width:30%;display: inline-block">
                        <template>
                            <span v-if="formData.isRelease == 1">开启</span>
                            <span v-if="formData.isRelease == 2">关闭</span>
                        </template>
                    </el-form-item>
                </el-form-item>
                <el-form-item
                    style="border-bottom:1px solid #ebeef5;"
                    label-width="0px"
                >
                    <el-form-item
                        label="排序:"
                        prop="slidepicsort"
                        style="width:30%;display: inline-block"
                    >
                        <input v-model="formData.sort" type="text" readonly/>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="轮播图片:" prop="slidepicsite">
                    <template>
                        <img
                            :src="formData.url"
                            style="width:400px;border-radius:3px;"
                        />
                    </template>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getBannerList,
        bannerDeleteSlidePic,
        addBanner,
        updateBanner,
        bannerStatus
    } from "../../api/slidepic/slidepic.js";
    import {BASE_URL} from "../../config/app";

    const formJson = {
        id: "",
        url: "",
        name: "",
        jumpUrl: "",
        isRelease: "",
        sort: "",

    };

    export default {
        data() {
            /* var checkTitle = (rule, value, callback) => {
                 if (!value) {
                     return callback(new Error("请输入标题"));
                 } else {
                     callback();
                 }
             };
             var checkSort = (rule, value, callback) => {
                 if (!value) {
                     return callback(new Error("请输入序列号"));
                 } else {
                     var reg = /^[0-9]*$/;
                     if (reg.test(value)) {
                         callback();
                     } else {
                         return callback(new Error("请输入正整数"));
                     }
                 }
             };
             var checkType = (rule, value, callback) => {

                 if (value!=null && value.length==0) {
                     return callback(new Error("请选择链接类型"));
                 } else {
                     callback();
                 }
             };

             var checkUrl = (rule, value, callback) => {
                 if (!value) {
                     return callback(new Error("请上传轮播图"));
                 } else {
                     callback();
                 }
             };*/


            return {
                name: "",
                dialogVisible: false,
                cancelToggle: false,
                servicestarttime: [],
                status: "",
                isRelease: "",
                query: {
                    id: "",
                    url: "",
                    name: "",
                    jumpUrl: "",
                    isRelease: "",
                    sort: "",
                    currentPage: 1,
                    pageSize: 10
                },
                list: [],
                totalNumber: 0,
                loading: true,
                index: null,
                formLoading: false,
                formVisible: false,
                formInfo: false,
                formInput: false,
                formData: formJson,
                formRules: {
                    /* name: [{ validator: checkTitle, trigger: "blur" }],
                     slidepicsort: [{ validator: checkSort, trigger: "blur" }],
                     slidepictype: [{ validator: checkType, trigger: "blur" }],
                      slidepicaddress: [{ validator: checkAddress, trigger: "blur" }],
                     slidepicsite: [{ validator: checkUrl, trigger: "blur" }],*/
                },
                multipleSelection: [], //多选集合
                uploadUrl: BASE_URL + "/upload/tool/uploadpro",
                pic_is_show: true,
            };
        },
        methods: {
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            dateChange(val) {
                if (val == null) {
                    this.query.startTime = "";
                    this.query.endTime = "";
                } else {
                    this.query.startTime = val[0];
                    this.query.endTime = val[1];
                }
                this.getList();
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            delGroup() {
                var ids = this.multipleSelection.map(item => item.slidepicid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                this.handleDel(ids);
            },
            onRest() {
                this.query = {
                    currentPage: 1,
                    pageSize: 10
                };
                this.msgtime = [];
                this.getList();
            },
            onSubmit() {
                this.$router.push({
                    path: "",
                    query: this.query
                });
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.getList();
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList();
            },
            handleAvatarSuccess(res, file) {
                this.formData.slidepicsite = res.data;
                console.info(res);
                console.info(file);
            },

            getList() {
                this.loading = true;
                console.log(this.query);
                getBannerList(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.errsor(response.message);
                        }

                        this.list = response.data.list || [];
                        this.totalNumber = response.data.totalNumber || 0;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                return true;
            },
            hideFormAdd() {
                // 更改值
                this.formInput = !this.formInput;
                return true;
            },

            hideFormInput() {
                // 更改值
                this.formInput = !this.formInput;
                return true;
            },

            hideInfo() {
                // 更改值
                this.formInfo = !this.formInfo;
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.$refs.tinymce.clearContent();
                this.query.name = "";
                return true;
            },
            hideInput() {
                // 更改值
                this.formInput = !this.formInput;
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.query.name = "";
                return true;
            },
            // 显示表单
            handleForm(index, row) {
                this.formVisible = true;
                this.formData = Object.assign({}, formJson);
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                //编辑
                if (index !== null) {
                    this.index = index;
                    this.formData = row;
                    let vm = this;
                    setTimeout(function () {
                        vm.$nextTick(() => {
                            if (vm.$refs.tinymce) {
                                vm.$refs.tinymce.setContent(vm.formData.problemanswer);
                            }
                        });
                    }, 350);
                }
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
            },

            handleInput(index, row) {
                this.formInput = true;
                this.formData = Object.assign({}, formJson);
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                //编辑
                if (index !== null) {
                    this.index = index;
                    let vm = this;
                    setTimeout(function () {
                        vm.$nextTick(() => {
                            if (vm.$refs.tinymce) {
                                vm.$refs.tinymce.setContent(vm.formData.problemanswer);
                            }
                        });
                    }, 350);
                }
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
            },

            handleInfo(index, row) {
                this.formInfo = true;
                this.formData = Object.assign({}, formJson);
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
            },

            formSubmit() {
                this.formLoading = true;
                this.formData.msgtime = "";
                let data = Object.assign({}, this.formData);
                updateBanner(data).then(response => {
                    this.formLoading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.$message.success("操作成功");
                    // 刷新表单
                    this.$refs["dataForm"].resetFields();
                    this.formVisible = false;
                    this.query.name = "";
                    this.getList();
                });
            },

            formSub() {
                this.formLoading = true;
                let data = Object.assign({}, this.formData);
                console.log(data);
                addBanner(data).then(response => {
                    this.formLoading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.$message.success("操作成功");
                    // 刷新表单
                    this.formInput = false;
                    this.query.name = "";
                    this.getList();
                });
            },
            //状态改变

            backgroundChange(row) {
                // eslint-disable-next-line no-unused-vars
                bannerStatus({id: row.id, isRelease: row.isRelease}).then((response) => {
                        this.$message({
                            type: "success",
                            message: "修改成功!",
                        });
                    }
                );
            },
            // 删除
            handleDel(ids) {
                if (ids) {
                    this.$confirm("确认要删除吗?", "提示", {
                        type: "warning"
                    })
                        .then(() => {
                            this.loading = true;
                            var params = new URLSearchParams();
                            params.append("ids", ids);
                            console.log("***************"+ids)
                            bannerDeleteSlidePic(params)
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("删除成功");
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.getList();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {
                        });
                }
            },
        },
        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            this.query = Object.assign(this.query, query);
            this.query.pageSize = parseInt(this.query.pageSize);
            // 加载表格数据
            this.getList();
        }
    };
</script>

<style type="text/scss" lang="scss">
    body {
        margin: 0;
    }

    .app_logo {
        width: 150px;
        height: 150px;
        border-radius: 5px;
        max-width: 150px;
        max-height: 150px;
    }

    .loading_div {
        width: 150px;
        height: 150px;
        border-radius: 5px;
        max-width: 150px;
        max-height: 150px;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px !important;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>
